import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Part, Gravity } from '@usimweb/core/models';

import { BoundingBoxService } from '@usimweb/core/services';

export interface KeyValue {
  key: string;
  value: string;
}

@Component({
    selector: 'app-mold-closing-dialog',
    templateUrl: './mold-closing-dialog.component.html',
    styleUrls: ['./mold-closing-dialog.component.scss'],
    standalone: false
})
export class MoldClosingDialogComponent implements OnInit, AfterViewInit {
  @Input() data = { gravity: { x: 0, y: 0, z: 0 }, modelId: 0 };

  @Output() saveCalled: EventEmitter<any> = new EventEmitter<any>();

  @Output() resetTrigger: EventEmitter<any> = new EventEmitter<any>();

  public saveResponse = new BehaviorSubject({});

  public parts: KeyValue[] = [];
  public key = 'key';
  public _value = 'value';

  public gravity: Gravity = { x: 0, y: 0, z: 0 };
  public modelId: number = 0;
  public part: string = '';
  public showSlider = false;

  constructor(private boundingBoxService: BoundingBoxService) {
    this.saveResponse.next({});
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.showSlider = true;
    }, 500);
  }

  ngOnInit(): void {
    this.gravity = this.data.gravity;
    this.modelId = this.data.modelId;
    this.getParts();
  }

  public save() {
    this.saveResponse.next({});
    const partName = this.parts.filter((x) => x.key == this.part);
    const dict = { openingVector: this.gravity, part: partName[0].value };
    setTimeout(() => {
      this.saveResponse.next(dict);
    });
  }

  //FIXME
  private getParts(): void {
    this.boundingBoxService.getParts(this.modelId).forEach((part: Part) => {
      this.parts.push({ key: part.partId, value: part.name });
    });
  }
}
